import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=6403f9a4&scoped=true&"
import script from "./Widgets.vue?vue&type=script&lang=ts&"
export * from "./Widgets.vue?vue&type=script&lang=ts&"
import style0 from "./Widgets.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Widgets.vue?vue&type=style&index=1&id=6403f9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403f9a4",
  null
  
)

export default component.exports